import { render } from "./NewCheckout.vue?vue&type=template&id=47f839f4"
import script from "./NewCheckout.vue?vue&type=script&lang=js"
export * from "./NewCheckout.vue?vue&type=script&lang=js"

import "./NewCheckout.vue?vue&type=style&index=0&id=47f839f4&lang=css"

import exportComponent from "/home/kira/codemark/zonadigital/frond/deploy/zona-digital-ecommerce-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__